import {
  Box,
  Heading,
  Text,
  Flex,
  Image,
  Link,
  Button,
} from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import Typed from "typed.js";
import professional from "../Assets/Resume/ProfilePicture.png";
import AOS from "aos";
import "aos/dist/aos.css";
import resume from "../Assets/Resume/Hemant-Yadav-Resume.pdf";
import {
  FaGithub,
  FaHeart,
  FaLinkedin,
  FaArrowCircleDown,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { FiPhoneCall } from "react-icons/fi";
import { Tooltip } from "@chakra-ui/react";
import Vector1 from "../Assets/img/Vector1.png";
import Vector2 from "../Assets/img/Vector2.png";

import "./Home.css";
import { themeContext } from "../Context";

export const Home = () => {
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);

  useEffect(() => {
    const typed = new Typed(".text", {
      strings: ["a Full Stack Developer", "skilled in MERN Stack"],
      typeSpeed: 100,
      backSpeed: 100,
      backDelay: 1000,
      loop: true,
      showCursor: false,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  // const openLink = (url) => {
  //   window.open(url);
  // };
  const openLink = (url) => {
    if (!url) {
      console.error("Invalid URL passed to openResume.");
      return;
    }
    window.open(url, "_blank"); // Open the resume in a new tab
  };

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <>
      <Flex
    mt={32}
        flexDirection={{
          base: "column-reverse",
          sm: "column-reverse",
          md: "column-reverse",
          lg: "row",
          xl: "row",
          "2xl": "row",
        }}
        // bg={"#162030"}
        
        justifyContent={"space-around"}
        alignItems={"center"}
        gap="60px"
        id="home"
        p="25px"
        w={"100%"}
        boxSizing="border-box"
        overflow={"hidden"}
        color={"white"}
        border="none"
        mb={28}
      >
        <Box>
          <Box id="home-content" textAlign={"left"}>
            <Heading
              fontFamily="initial"
              mt="10px"
              size="md"
              as="h3"
              className="head"
            >
              <span style={{ color: darkMode ? "white" : "black" }}>
                Hello👋, I am
              </span>
            </Heading>
            <Heading
              fontFamily="initial"
              mt="10px"
              size="2xl"
              as="h1"
              id="user-detail-name"
            >
              <span style={{ color: darkMode ? "white" : "black" }}>
                Hemant
              </span>
            </Heading>
            <Heading
              fontFamily="initial"
              mt="10px"
              size="2xl"
              as="h1"
              id="user-detail-name"
            >
              <span style={{ color: darkMode ? "white" : "black" }}>Yadav</span>
            </Heading>
            <Heading mt="10px" size="lg" as="h3" fontFamily="initial">
              <span style={{ color: darkMode ? "white" : "black" }}>I am </span>
              <span className="text"></span>
              <span style={{ color: "white", marginLeft: "3px" }}>|</span>
            </Heading>
            <Text
              fontFamily="cursive"
              fontSize={"20px"}
              mt="10px"
              style={{ color: "#788097" }}
            >
              Passionate Full Stack Web Developer proficient in MERN stack.
              <br />
              Excited to contribute innovative solutions and
              <br></br>
              collaborate in a dynamic team environment.
            </Text>
            <Flex
              flexDirection={{
                base: "column",
                sm: "column",
                md: "column",
                lg: "row",
                xl: "row",
                "2xl": "row",
              }}
              justifyContent={"space-between"}
            >
              <Flex alignItems={"center"}>
                <Link
                  id="contact-github"
                  href="https://github.com/Hemant142/"
                  isExternal
                >
                  <FaGithub
                    className="contact-logo"
                    style={{ color: darkMode ? "white" : "#FCA61F" }}
                  />
                </Link>
                <Link
                  id="contact-linkedin"
                  href="https://www.linkedin.com/in/hemant-yadav-868296278/"
                  isExternal
                >
                  <FaLinkedin
                    style={{
                      marginLeft: "20px",
                      color: darkMode ? "white" : "#FCA61F",
                    }}
                    className="contact-logo"
                  />
                </Link>

                <Link id="contact-linkedin" href="tel:+919911695440" isExternal>
                  <FiPhoneCall
                    style={{
                      marginLeft: "20px",
                      color: darkMode ? "white" : "#FCA61F",
                    }}
                    className="contact-logo"
                  />
                </Link>

                <Link
                  id="contact-linkedin"
                  href="mailto:yhemant203@gmail.com"
                  isExternal
                >
                  <HiOutlineMail
                    style={{
                      marginLeft: "20px",
                      color: darkMode ? "white" : "#FCA61F",
                    }}
                    className="contact-logo"
                  />
                </Link>
              </Flex>

              <Link
                mt="10px"
                fontWeight="bold"
                borderRadius="5px"
                id="resume-link-2"
                href={resume}
                download={true}
                target="_blank"
              >
                <Box className="home-icon">
                  <Button
                    mt="10px"
                    id="resume-button-2"
                    background="#FCA61F"
                    color={"white"}
                    onClick={() =>
                      openLink(
                        "https://drive.google.com/file/d/1HB4sxQnjmlM1nWzvcng85FF9-1qe_fhu/view?usp=sharing"
                      )
                    }
                    className="home-resume btn-box home-icon button i-button "
                  >
                    Resume
                    <FaArrowCircleDown marginLeft="5px" />
                  </Button>
                </Box>
              </Link>
            </Flex>
          </Box>
        </Box>

        <Image
          id="mypic"
          src={"https://i.postimg.cc/26mkTTfR/Professional-Pic.png"}
          className="home-img "
          boxShadow={darkMode ? "0 0 10px white" : "0 0 20px #FCA61F"}
          border={"2px solid red"}
          borderColor={darkMode ? "white" : "#FCA61F"}
          margin="auto"
          alt="ProfilePicture"
          w={{
            base: "100%",
            sm: "80%",
            md: "60%",
            lg: "20%",
            xl: "20%",
            "2xl": "30%",
          }}
          height={"300px"}
          borderRadius="3%"
        />

        {/*       
<Box className="i-right" 
         w={{
          base: "100%",
          sm: "80%",
          md: "60%",
          lg: "20%",
          xl: "20%",
          "2xl": "30%",
        }}
        height={"100px"}
        >
        <img src={Vector1} alt="" />
        <img src={Vector2} alt="" />
        <img src={professional} alt="" style={{ marginLeft: "100px" }}  id="mypic" className="home-img"/>
        <Image
          id="mypic"
          src={professional}
          className="home-img"
          boxShadow="0 0 10px white"
          border={"2px solid red"}
          borderColor={"#FCA61F"}
          alt="ProfilePicture"
          w={{
            base: "100%",
            sm: "80%",
            md: "60%",
            lg: "20%",
            xl: "20%",
            "2xl": "30%",
          }}
          height={"450px"}
          borderRadius="3%"
        /> 
        <div initial={{left: '-36%'}} whileInView={{left: '-24%'}} transition={transition} style={{top: '-3%', left:'-17%'}} className='floating-div'>
            <FloatingDiv image={thumbup} text1='Responsive Web' text2='Design'/>
        </div>
        <div style={{top: '-7%', left:'75%'}} className='floating-div'>
            <FloatingDiv image={Crown} text1='Full Stack' text2='Web Developer'/>
        </div>
        <div style={{top: '18rem', left:'1.4rem'}} className='floating-div'>
            <FloatingDiv image={thumbup} text1='Mern Stack' text2='Developer'/>
        </div>
        <div className="blur" style={{ background: "rgb(238 210 255)" }}></div>
        <div
          className="blur"
          style={{
            border:"2px solid red",
            background: "#C1F5FF",
            top: "-5rem",
            width: "100%",
            height: "100%",
            left: "-6rem",
          }}
        ></div>
      </Box> */}
      </Flex>
    </>
  );
};

//   export default Home;
